import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatTab, MatTabGroup } from '@angular/material/tabs';
import { RouterLink } from '@angular/router';
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';
import { TitleComponent } from 'src/app/shared/components/title/title.component';
import {
  Exercise,
  ExerciseCardComponent,
} from 'src/app/shared/components/vacations/exercise-card/exercise-card.component';
import { LoaderService } from 'src/app/shared/services/loader/loader.service';
import { HolidaysService } from 'src/app/shared/services/holidays/holidays.service';
import { ExerciseResponse } from 'src/app/shared/interfaces/holidays.interface';

@Component({
  selector: 'app-management',
  imports: [
    LoaderComponent,
    MatTabGroup,
    MatTab,
    TitleComponent,
    MatButtonModule,
    ExerciseCardComponent,
    RouterLink,
  ],
  templateUrl: './management.component.html',
  styleUrls: ['./management.component.css', '../../../shared/styles/layout.css'],
})
export class ManagementComponent implements OnInit {
  title: string = 'Vacaciones chóferes';
  subtitle: string =
    'Consulta los detalles generales de las vacaciones de los chóferes.';

  data: Exercise[] = [];

  constructor(
    private loaderService: LoaderService,
    private holidaysService: HolidaysService
  ) {}

  ngOnInit(): void {
    this.loadExercises();
  }

  loadExercises(): void {
    this.loaderService.showLoader();
    this.holidaysService.getExercises(false).subscribe({
      next: (exercises: ExerciseResponse[]) => {
        this.data = this.mapExercisesToUI(exercises);
        this.loaderService.hideLoader();
      },
      error: (error) => {
        console.error('Error loading exercises:', error);
        this.loaderService.hideLoader();
      },
    });
  }

  private mapExercisesToUI(exercises: ExerciseResponse[]): Exercise[] {
    return exercises.map((exercise) => ({
      id: exercise.id,
      title: exercise.name,
      year: exercise.year,
      active: exercise.active,
      continuous_phase: exercise['configuration']?.continuous_phase || false,
      initial_petition: exercise['configuration']?.initial_petition || false,
      dates: this.formatDateRange(exercise.start_date, exercise.end_date),
      bottomCardData: [
        { title: 'CHÓFERES', value: exercise.stats?.choferes_count || 0 },
      ],
    }));
  }

  private formatDateRange(startDate: string, endDate: string): string {
    const formatDate = (dateStr: string): string => {
      const date = new Date(dateStr);
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    };

    return `${formatDate(startDate)} - ${formatDate(endDate)}`;
  }

  get isLoading(): boolean {
    return this.loaderService.getLoader();
  }
}
